<template>
    <div>
        <base-pill-button class="mb-1" @click="getZiBasic">Get ZI Basic</base-pill-button>
    </div>
</template>

<script>
    export default {
        name: "get-zi-basic-button"
    }
</script>

<script setup>
import { defineEmits, defineProps } from 'vue';
import { getZoomInfoBasic } from '@/services/Company'
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';

    const store = useStore()
    const $toast = useToast()

    const props = defineProps({
        company: Object
    })

    const emit = defineEmits(['refetch-companies'])

    async function getZiBasic () {
        console.log('getZIBasic button method')
        const token = store.state.auth.token
        const result = await getZoomInfoBasic(props.company.id, token)
        console.log(result)
        if(result.status == 200) {
            $toast.open({
                message: result.data.status,
                type: 'success',
                duration: 5000
            })
        } else {
            $toast.open({
                message: 'Error updating ZI Basic.',
                type: 'error',
                duration: 5000
            })
        }
        emit('refetch-companies')
    }

</script>